// @ts-nocheck

import { useScriptTag } from '@vueuse/core'
export default defineNuxtPlugin(() => {
  const dataLayer = []

  const serverInit = () => {
    useHead({
      script: [
        {
          key: 'dataLayer',
          children: `window.dataLayer = ${JSON.stringify(dataLayer)}`
        }
      ]
    })
  }

  const push = event => {
    if (process.server) { return dataLayer.push(event) }
    setTimeout(() => {
      return window.dataLayer.push(event)
    }, 200)
  }

  if (!process.server) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(), event: 'gtm.js'
    })

    setTimeout(() => {
      useScriptTag('https://www.googletagmanager.com/gtm.js?id=GTM-WDZT9PM&l=dataLayer', () => {}, { async: true })
    }, 3000)
  }

  return {
    provide: {
      gtm: {
        push,
        serverInit
      }
    }
  }
})
